import { Component, OnInit, inject } from '@angular/core';

import { NHASnackbarService } from '../snack-bar';
import * as Cookies from 'es-cookie';
import { getAppDomain } from '@nha/functions';
import { endOfDay, isBefore, parseISO } from 'date-fns';
import { appSettings } from '@nha/config';

@Component({
	selector: 'nha-maintenance-notification',
	imports: [],
	template: ``
})
export class MaintenanceNotificationComponent implements OnInit {
	private _snackbarService = inject(NHASnackbarService);

	ngOnInit(): void {
		if (appSettings.dbSettings?.['maintenanceNotification']) {
			this.showMaintenanceNotification();
		}
	}

	private showMaintenanceNotification() {
		const notification = this.parseAppSetting();
		if (notification && !this.hasDismissed(notification.id) && isBefore(new Date(), endOfDay(notification.date))) {
			const snackbarRef = this._snackbarService.warn(
				`<strong>${notification.title}</strong><p>${notification.message}</p>`,
				'Dismiss',
				{ duration: 0 },
				true
			);
			snackbarRef.afterDismissed().subscribe(() => {
				Cookies.set('maintenanceNotificationDismissed', notification.id, { path: '/', secure: true, domain: getAppDomain(), expires: 1 });
			});
		}
	}

	private parseAppSetting() {
		try {
			const notification = JSON.parse(appSettings.dbSettings['maintenanceNotification']);
			if (notification.date && notification.message && notification.title) {
				notification.date = parseISO(notification.date);
				return notification;
			}
		} catch (e) {
			return null;
		}
	}

	private hasDismissed(id: number) {
		const notificationID = Cookies.get('maintenanceNotificationDismissed');
		return notificationID && notificationID === id.toString();
	}
}
